module.exports = __webpack_public_path__ + "static/img/solve.d80b6a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solve.jpg
// module id = nsAl
// module chunks = 1